<template>
	<section class="small-12 leasesListing propertyListingsPage" v-if="property && user">
		<section class="small-12 columns pageTitle flex justify-center">
			<div class="small-12 flex vertical-align">
				<div class="small-12 large-9 columns flex vertical-align">
					<h1 class="auto flex vertical-align">
						Resident Overview 
					</h1>
					<ul class="auto float-left flex vertical-align crumbs">
						<li>
							<span class="round separator bgPrimaryBlue"></span>
						</li>
						<li>
							<p class="small-12 flex vertical-align" v-if="unit">
								<b class="flex">Unit:</b> 
								<router-link :to="{ name: 'Unit', params: { id: $route.params.id, unitID: unit.id } }" class="flex vertical-align borderRadius2">
									{{ unit.attributes.number }}
									<i class="material-icons border round">chevron_right</i>
								</router-link>
							</p>
						</li>
					</ul>
				</div>
				<div class="small-12 large-3 columns searchContainer">
					<ul class="small-12 flex justify-right vertical-align">
						<li class="addMenu" v-if="user">
							<a class="blueButton flex vertical-align justify-center borderRadius4" @click="openEditResidentMenu()">
								<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">edit</i>
								Edit Resident
							</a>
						</li>
					</ul>
				</div>
			</div>
		</section>
		<div class="small-12 flex listingsContainer">
			<section class="small-12 large-8 flex justify-center listings border-right listingsContainerWrap" v-bind:class="{ zIndex: set_index }">
				<div class="small-12 columns" style="margin-top:30px;">
					<ul class="small-12 columns float-left">
						<li class="small-12">
							<resident-details :unit="unit" :resident="resident" :lease="lease" :rent="rent"/>
						</li>
					</ul>
				</div>
				<div class="small-12 columns listingsTitle animated fadeIn">
					<div class="small-12 flex vertical-align">
						<h3 class="small-3 columns flex vertical-align">
							Leases 
						</h3>
						<div class="small-9 columns searchContainer" style="margin-bottom:20px;">
							<ul class="small-12 flex justify-right vertical-align">
								<li class="reportsMenu">
									<a ref="leaseFilters" class="flex justify-center vertical-align borderRadius4" @click="showFilterDropdownMenu()">
										<i class="material-icons-outlined chartIcon flex justify-center vertical-align borderRadius4">filter_alt</i>
										Filter
									</a>
									<div ref="leaseFiltersMenu" class="auto filterDropdownMenu animated fadeIn" v-show="show_filter_menu_dropdown">
										<div class="small-12 filterWrap borderRadius4">
											<div class="small-12 filterMenuLabel">
												<p>Quick Filters</p>
											</div>
											<a class="small-12 menuItem flex vertical-align" @click="filterBy('pending')">
												<i class="material-icons-outlined">pending</i>
												Pending
											</a>
											<a class="small-12 menuItem flex vertical-align" @click="filterBy('active')">
												<i class="material-icons-outlined">event</i>
												Active
											</a>
											<a class="small-12 menuItem flex vertical-align" @click="filterBy('expired')">
												<i class="material-icons-outlined">restore</i>
												Expired
											</a>
											<a class="small-12 menuItem flex vertical-align" @click="viewAllListings()">
												<i class="material-icons-outlined">list</i>
												View All
											</a>
										</div>
									</div>
								</li>
								<li class="search small-12 large-3" @click="resetIndex($event)">
									<datetime :placeholder="'Search by Date'" v-model="search_query" value-zone="local" zone="local" :phrases="{ok: 'Select', cancel: 'Cancel'}" :format="{ month: 'numeric', day: 'numeric', year: 'numeric' }" @input="searchResults($event)"></datetime>
									<label class="borderRadius4 flex vertical-align transition">
										<i class="material-icons-outlined">search</i>
										Search by Date
									</label>
								</li>
								<li class="addMenu" v-if="user">
									<a class="blueButton flex vertical-align justify-center borderRadius4" @click="openAddLeaseMenu()" v-if="user.relationships.company && units_exist && residents_exist">
										<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
										Add Lease
									</a>
									<a class="blueButton disabledButton disabled flex vertical-align justify-center borderRadius4" v-else>
										<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
										Add Lease
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="small-12 columns listingsTable inPage">
					<div class="small-12 columns head">
						<ul class="small-12 columns flex vertical-align">
							<li class="small-12 large-5 columns flex vertical-align">
								<p class="flex vertical-align">
									Lease
								</p>
							</li>
							<li class="small-12 large-2 columns flex vertical-align end">
								<p class="flex vertical-align">
									Unit
								</p>
							</li>
							<li class="small-12 large-2 columns flex vertical-align end">
								<p class="flex vertical-align">
									Status
								</p>
							</li>
							<li class="small-12 large-2 columns flex vertical-align end">
								<p class="flex vertical-align">
									Expires In
								</p>
							</li>
						</ul>
					</div>
					<div class="small-12 columns body">
						<div class="small-12" v-if="search_query">
							<div class="small-12 flex listingsDiv" v-if="queried_results.length > 0">
								<lease :resident="resident" :lease="leaseObj" v-for="(leaseObj, index) in queried_results" :key="index"/>
							</div>
							<ul class="small-12 columns flex animated fadeIn" v-else>
								<li class="small-12">
									<div class="small-12 emptyResults flex justify-center">
										<picture class="small-12 flex justify-center">
											<img width="120" :src="empty_image" alt="Nestd Logo in a House">
										</picture>
										<h6 class="small-12 text-center">
											0 results found
										</h6>
										<p class="small-12 text-center">
											No leases have been found for that selection.
										</p>
									</div>
								</li>
							</ul>
						</div>
						<div class="small-12" v-if="!search_query">
							<div class="small-12 flex listingsDiv" v-if="leases && leases.length > 0">
								<lease :resident="resident" :lease="leaseObj" v-for="(leaseObj, index) in leases" :key="index"/>
							</div>
							<ul class="small-12 columns flex animated fadeIn" v-else>
								<li class="small-12">
									<div class="small-12 emptyResults flex justify-center">
										<picture class="small-12 flex justify-center">
											<img width="120" :src="empty_image" alt="Nestd Logo in a House">
										</picture>
										<h6 class="small-12 text-center">
											0 results found
										</h6>
										<p class="small-12 text-center">
											No leases have been added to this property yet.
										</p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<user-footer/>
			</section>
			<section class="small-12 large-4 flex overviewPanel" v-bind:class="{ active: a_menu_is_open }">
				<div class="small-12 panelWrap" v-bind:class="{ active: a_menu_is_open }">
					<div class="small-12 companyNeeded borderRadius8 border" v-if="!user.relationships.company">
						<picture class="small-12 flex justify-center">
							<img :src="empty_company_image" alt="Company Vector">
						</picture>
						<h2 class="small-12 columns text-center">No Company Found</h2>
						<p class="small-12 columns text-center">Please set up your company first before adding rent to this lease.</p>
						<div class="small-12 action flex justify-center">
							<router-link :to="{ name: 'SettingsCompany' }" class="blueButton flex vertical-align justify-center borderRadius4">
								<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
								Set Up Company
							</router-link>
						</div>
					</div>
					<div class="small-12 panelBody flex vertical-align" v-else>
						<resident-portal-management :resident="resident" :property="property"/>
						<latest-timeline :lease="lease"/>
					</div>
				</div>
				<div class="small-12 panelBody flex" style="padding-top:0;" v-if="!units_exist || !residents_exist">
					<div class="small-12 nextSteps">
						<div class="small-12 table border borderRadius8">
							<div class="small-12 columns tableHead">
								<div class="small-12 tableRow">
									<div class="small-12 tableCell">
										<h4>Follow these steps to get started.</h4>
									</div>
								</div>
							</div>
							<div class="small-12 columns tableBody animated fadeIn">
								<div class="small-12 tableRow" style="padding-top:10px;">
									<div class="small-12 tableCell border-bottom light">
										<p class="small-12">
											<router-link :to="{ name: 'PropertyUnits', params: { id: property.id } }" class="small-12 text-overflow flex vertical-align justify-between">
												<span class="float-left">
													Create your first unit.
												</span>
												<i class="material-icons-outlined">play_circle_filled</i>
											</router-link>
										</p>
									</div>
								</div>
								<div class="small-12 tableRow">
									<div class="small-12 tableCell">
										<p class="small-12">
											<router-link :to="{ name: 'PropertyResidents', params: { id: property.id } }" class="small-12 text-overflow flex vertical-align justify-between">
												<span class="float-left">
													Create your first resident.
												</span>
												<i class="material-icons-outlined">play_circle_filled</i>
											</router-link>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<add-lease-menu ref="addLeaseMenu" :menu_action="open_add_lease_menu" :property="property" :company="company" :resident="resident" :unit="unit" @closeAddLeaseMenu="closeAddLeaseMenu" @setCalendarPickerIndex="setCalendarPickerIndex"/>
				<edit-resident-menu ref="editResidentMenu" :menu_action="open_edit_resident_menu" :resident="resident" :property="property" @closeEditResidentMenu="closeEditResidentMenu"/>
			</section>
		</div>
	</section>
</template>

<script>

	// Import the components
	import UserFooter from '@/components/framework/footer/UserFooter.vue'
	import Lease from '@/components/property/leases/Lease.vue'
	import LatestTimeline from '@/components/property/leases/LatestTimeline.vue'
	import AddLeaseMenu from '@/components/property/leases/AddLeaseMenu.vue'
	import ResidentDetails from '@/components/property/leases/ResidentDetails.vue'
	import { Datetime } from 'vue-datetime'
	import ResidentPortalManagement from '@/components/property/leases/ResidentPortalManagement.vue'
	import EditResidentMenu from '@/components/property/leases/EditResidentMenu.vue'

	// Import the services
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

	// Import the events
	import { BindToLeases } from '@/events/leases/BindToLeases'
	import { GetPropertyUnits } from '@/events/units/GetPropertyUnits'
	import { GetPropertyResidents } from '@/events/residents/GetPropertyResidents'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'LeasesListing',

		/*
		**  Register the components
		*/

		components: {

			UserFooter,
			Lease,
			LatestTimeline,
			AddLeaseMenu,
			ResidentDetails,
			datetime: Datetime,
			ResidentPortalManagement,
			EditResidentMenu

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			BindToLeases,
			GetPropertyUnits,
			GetPropertyResidents

		],

		/*
		**  Set the props
		*/

		props: {

			user: {
				type: Object,
				default: () => null
			},

			property: {
				type: Object,
				default: () => null
			},

			company: {
				type: Object,
				default: () => null
			},

			resident: {
				type: Object,
				default: () => null
			},

			unit: {
				type: Object,
				default: () => null
			},

			lease: {
				type: Object,
				default: () => null
			},

			rent: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			future_item: false,
			units_exist: false,
			residents_exist: false,
			empty_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/logos%2Fnestd-logo-house.svg?alt=media&token=782a6239-e56b-4366-9ed5-b278ad5ea9e4',
			empty_company_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fempty-operations.svg?alt=media&token=1ee6789f-1ad3-4348-aeeb-539c8a687584',
			search_query: '',
			queried_results: [],
			open_add_lease_menu: false,
			show_filter_menu_dropdown: false,
			a_menu_is_open: false,
			open_edit_resident_menu: false,
			set_index: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			property: {

				immediate: true, // Load on created
				handler(property) {

					/*
					**  Bind to the leases
					**  @method: Events/Leases/BindToLeases
					*/

					if (property) this.bindToLeasesHandler(this.$route.params.id, this.$route.params.residentID);

					/*
					**  Units exist check
					**  @method: Events/Units/GetPropertyUnits
					*/

					if (property) this.getPropertyUnitsHandler(this.$route.params.id);

					/*
					**  Residents exist check
					**  @method: Events/Residents/GetPropertyResidents
					*/

					if (property) this.getPropertyResidentsHandler(this.$route.params.id);

				}

			},

			units: {

				immediate: true, // Load on created
				handler(units) {

					/*
					**  Set the units exist check prop
					**  @prop: @here
					*/

					if (units.length > 0) this.units_exist = true;

				}

			},

			residents: {

				immediate: true, // Load on created
				handler(residents) {

					/*
					**  Set the residents exist check prop
					**  @prop: @here
					*/

					if (residents.length > 0) this.residents_exist = true;

				}

			}

		},

		/*
        ** Do this first
        */

        created() {

        	window.addEventListener('click', this.closeFilterMenu);

        },

		beforeDestroy() {

			window.removeEventListener('click', this.closeFilterMenu);

		},

        /*
		**  Set up the methods
		*/

		methods: {

			openAddLeaseMenu: function() {

				try {

					/*
					**  Close the menus
					**  @props: @here
					*/

					if(this.open_edit_resident_menu) this.$refs.editResidentMenu.closeEditResidentMenu();

					/*
					**  Open the menu
					**  @prop: @here
					*/

					this.open_add_lease_menu = true;

					/*
					**  Set the active class on the details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = true;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Open the add lease menu.',
                        errorType: 'Firestore Database',
                        section: 'Resident Overview',
                        uid: 'U32AkNpW9EkaczVne6aa',
                        error: e
                    });

				}

			},

			closeAddLeaseMenu: function(value) {

				try {

					/*
					**  Close the menu
					**  @prop: @here
					*/

					this.open_add_lease_menu = false;

					/*
					**  Remove the active class on the lease details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = false;

				} catch (e) {

					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Close the add lease menu.',
                        errorType: 'Firestore Database',
                        section: 'Resident Overview',
                        uid: '5VtfFyT5I9LDGxtms22G',
                        error: e
                    });

				}
				
			},

			searchResults: function (event) {

				try {

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.queried_results = [];

					/*
					**  Filter the data
					*/

					if (event) {

						/*
						**  Set the vars
						*/

						let searchQuery = moment(this.search_query),
							isValid = searchQuery.isValid();

						if (this.leases.length > 0 && isValid) {

							return this.leases.filter((item)=>{

								let start_date = moment(item.attributes.details.start_date),
									end_date = moment(item.attributes.details.end_date),
									isBetween = moment(searchQuery).isBetween(moment(start_date * 1000), moment(end_date * 1000));

								if (isBetween) return this.queried_results.push(item);

							});

						} else {

							/*
							**  Set the full list of rents
							*/

							return this.queried_results = this.leases;

						}

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to Search for a Resident Lease.',
						errorType: 'Application',
						section: 'Resident Overview',
						uid: 'gImbp7tHxqf2bzm5gwWM',
						error: e
					});

				}

			},

			viewAllListings: function() {

				try {

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.queried_results = [];

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.search_query = '';

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to View All of the Resident Leases Listings',
						errorType: 'Application',
						section: 'Resident Overview',
						uid: 'p00JJ0jKcksGWtZttl6S',
						error: e
					});

				}

			},

			filterBy: function(value) {

				try {

					/*
					**  Set the search query
					**  @prop: @here
					*/

					this.search_query = value;

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.queried_results = [];

					/*
					**  Filter the results
					**  @prop: @here
					*/

					if (this.leases.length > 0 && value) {

						return this.leases.filter((item)=>{

							if (item.attributes.status.toLowerCase().includes(value.toLowerCase())) {

								return this.queried_results.push(item);

							}

						});

					} else {

						/*
						**  Set the full list of rents
						*/

						return this.queried_results = this.leases;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to apply a lease filter when filtering leases.',
						errorType: 'Application',
						section: 'Resident Overview',
						uid: 'Ol9D8XLgxvKyFJW6YyCs',
						error: e
					});

				}

			},

			showFilterDropdownMenu: function() {

				try {

					/*
					**  Set the prop
					**  @prop: @here
					*/

					if (!this.show_filter_menu_dropdown) {

						this.show_filter_menu_dropdown = true;

					} else {

						this.show_filter_menu_dropdown = false;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to Show the Filter Dropdown Menu',
						errorType: 'Application',
						section: 'Resident Overview',
						uid: '1CcDf0r9AOUzf95YSpAW',
						error: e
					});

				}

			},

			closeFilterMenu(evt) {

				try {

					let containsElement = this.$el.contains(evt.target),
						parentElement = evt.target.parentElement;

					/*
					**  If menu wasn't clicked
					*/

					if (evt.target !== this.$refs['leaseFiltersMenu'] && evt.target !== this.$refs['leaseFilters'] && parentElement !== this.$refs['leaseFilters']) {

						/*
						**  Set the prop
						**  @prop: @here
						*/

						this.show_filter_menu_dropdown = false;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to close the lease filter menu',
						errorType: 'Application',
						section: 'Resident Overview',
						uid: 'O8gRwdEu7SDggR8oDUWi',
						error: e
					});

				}

		    },

			openEditResidentMenu: function(value) {

				try {

					/*
					**  Close the menus
					**  @props: @here
					*/

					if (this.open_add_lease_menu) this.$refs.addLeaseMenu.closeMenu();

					/*
					**  Open the edit resdient menu
					**  @prop: @here
					*/

					this.open_edit_resident_menu = true;

					/*
					**  Set the active class on the details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to open the edit resident menu.',
						errorType: 'Application',
						section: 'Resident Overview',
						uid: 'EqFW8dWeuo4VFpQaM3Gp',
						error: e
					});

				}

			},

			closeEditResidentMenu: function(value) {

				try {

					/*
					**  Open the modal
					**  @prop: @here
					*/

					this.open_edit_resident_menu = false;

					/*
					**  Remove the active class on the lease details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = false;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Close the Edit Resident Menu',
						errorType: 'Application',
						section: 'Resident Overview',
						uid: 'CoOSsvQEfPmdOS3ubutI',
						error: e
					});

				}

			},

			resetIndex: function(event) {

				try {

					/*
					**  Set the prop
					**  @prop: @here
					*/

					this.set_index = false;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Reset the calendar index.',
						errorType: 'Application',
						section: 'LeasesListing',
						uid: '7enJXeiqy0OBoaLzwwgG',
						error: e
					});

				}

			},

			setCalendarPickerIndex: function(event) {

				try {

					/*
					**  Set the prop
					**  @prop: @here
					*/

					this.set_index = true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Set the calendar index.',
						errorType: 'Application',
						section: 'LeasesListing',
						uid: 'QF4vGAxzYbYfJLYdqVqh',
						error: e
					});

				}

			},

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>